import { View } from "@/components/ui";
import { Typography } from "../typography";

export const TextSeparator = ({ label }: { label: string }) => {
  return (
    <View className="flex flex-1 flex-row items-center gap-1">
      <View className="divider h-[1px] flex-1 bg-border" />

      <Typography
        className="h-4"
        variant="body-sm"
        color="foreground-intermediate"
      >
        {label}
      </Typography>

      <View className="divider h-[1px] flex-1 bg-border" />
    </View>
  );
};
